import { useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useSeo } from "../lib/seo";
import { BUSINESS, ROLES, SERVICES, SOCIAL } from "../data/content";
import { PageIntro } from "../components/site/Sections";
import { ConsultationForm } from "../components/forms/ConsultationForm";
import { QuoteForm } from "../components/forms/QuoteForm";

export default function Contact() {
  useSeo("Contact", "Request a consultation, book an appointment or request a quote from Deaf Education Consulting LLC. In person or virtual, worldwide.");
  const [params] = useSearchParams();
  const { hash } = useLocation();
  const role = ROLES.includes(params.get("role")) ? params.get("role") : "";
  const svcOptions = [...SERVICES.map((s) => s.title), "Guest speaking"];
  const service = svcOptions.includes(params.get("service")) ? params.get("service") : "";

  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash]);

  return (
    <>
      <PageIntro eyebrow="Contact" title="Let's talk about your student" testid="contact-intro">
        <p>Requesting a consultation is the best first step. Prefer to pick a time yourself? <Link to="/book" className="text-teal underline underline-offset-4" data-testid="contact-book-link">Book an appointment</Link>. Need pricing for a project? <a href="#quote" className="text-teal underline underline-offset-4" data-testid="contact-quote-jump">Request a quote</a>.</p>
      </PageIntro>
      <section className="bg-sky text-ink py-20 md:py-28">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-[1.35fr_1fr] gap-10 items-start">
          <div id="consultation" className="scroll-mt-8" data-testid="consultation-section">
            <h2 className="font-display">Request a consultation</h2>
            <p className="mt-3 mb-10 text-slate">Tell me about your student, team or project. Fields marked * are required.</p>
            <ConsultationForm defaultRole={role} defaultService={service} key={role + service} />
          </div>
          <div id="quote" className="scroll-mt-8 bg-paper rounded-2xl p-6 md:p-8" data-testid="quote-section">
            <h2 className="font-display !text-3xl">Request a quote</h2>
            <p className="mt-3 mb-8 text-slate">For trainings, program support, assessments or speaking.</p>
            <QuoteForm />
          </div>
        </div>
      </section>
      <section className="bg-cream text-ink py-16" data-testid="contact-details">
        <div className="max-w-6xl mx-auto px-6 grid sm:grid-cols-3 gap-8 font-sans">
          <div><p className="lbl text-teal">Email</p><p className="mt-2"><a href={`mailto:${BUSINESS.email}`} className="link-u break-all" data-testid="contact-email">{BUSINESS.email}</a></p></div>
          <div><p className="lbl text-teal">Phone</p><p className="mt-2"><a href={`tel:+1${BUSINESS.phone.replace(/\D/g, "")}`} className="link-u" data-testid="contact-phone">{BUSINESS.phone}</a></p></div>
          <div><p className="lbl text-teal">Where</p><p className="mt-2">Licensed in Pennsylvania. Worldwide, in person or virtual. Travel season: June, July, August.</p></div>
          <div className="sm:col-span-3"><p className="lbl text-teal">Follow</p>
            <ul className="mt-2 flex flex-wrap gap-6">
              {SOCIAL.map((s) => <li key={s.label}><a href={s.url} target="_blank" rel="noreferrer" className="link-u" data-testid={`contact-social-${s.label.toLowerCase()}`}>{s.label}: {s.handle}</a></li>)}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
